<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :viewBox="getViewBox"
    :width="`${width}px`"
    :height="`${height}px`"
    :fill="colorFill"
  >
    <path
      d="M 12 0 C 5.371094 0 0 5.371094 0 12 C 0 18.628906 5.371094 24 12 24 C 18.628906 24 24 18.628906 24 12 C 24 5.371094 18.628906 0 12 0 Z M 12 2 C 17.523438 2 22 6.476563 22 12 C 22 17.523438 17.523438 22 12 22 C 6.476563 22 2 17.523438 2 12 C 2 6.476563 6.476563 2 12 2 Z M 10.9375 3.875 L 10.5 12.0625 L 10.59375 12.9375 L 16.75 18.375 L 17.71875 17.375 L 12.625 11.96875 L 12.1875 3.875 Z"
    />
  </svg>
</template>
<script>
export default {
  name: 'IconClock',
  props: {
    width: {
      type: Number,
      default: 16,
    },
    height: {
      type: Number,
      default: 16,
    },
    colorFill: {
      type: String,
      default: 'currentColor',
    },
  },
  computed: {
    getViewBox() {
      const boxWidth = this.width * 1.5;
      const boxHeight = this.height * 1.5;

      return `0 0 ${boxWidth} ${boxHeight}`;
    },
  },
};
</script>
